import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          Hacky World
        </p>
      </header>
    </div>
  );
}

export default App;
